import { useEffect, useState, useCallback } from "react";
import Accordion from "../Accordion/Accordion";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdCloudUpload } from "react-icons/md";
import MultiSelectDropdown from "../../../shareableContainer/MultiSelect";
import MediaUpload from "../MediaUpload";
import LocationService from "../../../Services/LocationService";
import AmenitiesService from "../../../Services/AmenitiesService";
import SpinWheelService from "../../../Services/SpinWheelService";
import Select from "react-select";
import { toast } from "react-toastify";
import { constructionType, underOfGovernances } from "../../../../Enum";
import teamService from "../../../Services/TeamService";
import { VscLockSmall } from "react-icons/vsc";
import { showWarningToast } from "../../../Constant/Notification";
import CustomInput from "../../../common/CustomInput";

const VillaPropertyInfoForm = ({
  propertyInfo,
  setPropertyInfo,
  handlePropertyInfoChange,
  handleArrayFieldChange,
  isEdit,
  propertyType,
  propertySaleTypesName,
}) => {
  const [thumbnail, setThumbnail] = useState(
    propertyInfo?.propertyThumbnail || ""
  );

  console.log("propertyType :", propertyType);
  const [locationData, setLocationData] = useState([]);
  const [basicAmenities, setBasicAmenities] = useState([]);
  const [featuresAmenities, setFeaturesAmenities] = useState([]);
  const [nearbyAmenities, setNearbyAmenities] = useState([]);
  const [salesTeamOptions, setSalesTeamOptions] = useState([]);
  const [videoLink, setVideoLink] = useState(
    propertyInfo?.propertyVideos?.[0] || ""
  );

  const [selectedBasicAmenities, setSelectedBasicAmenities] = useState([]);
  const [selectedFeaturesAmenities, setSelectedFeaturesAmenities] = useState(
    []
  );
  const [selectedNearbyAmenities, setSelectedNearbyAmenities] = useState([]);
  const [selectedSalesTeam, setSelectedSalesTeam] = useState([]);

  const [isAmenitiesLoaded, setIsAmenitiesLoaded] = useState(false);
  const [isSalesTeamLoaded, setIsSalesTeamLoaded] = useState(false);

  const [videoError, setVideoError] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const rawData = response.data || {};
        const formattedData = Array.isArray(rawData)
          ? rawData.map((item) => ({
              label: item.label || item.name || "",
              id: item.id,
            }))
          : Object.entries(rawData).map(([label, id]) => ({
              label,
              id,
            }));
        setLocationData(formattedData);
      } catch (error) {
        console.error("Error fetching location data:", error);
        toast.error("Failed to load locations");
      }
    };
    fetchLocationData();
  }, []);

  const fetchSalesTeamData = async () => {
    try {
      const responseSale = await teamService.getTeamName();
      const saleTeams = Array.isArray(responseSale.data?.teams)
        ? responseSale.data?.teams
        : [];
      setSalesTeamOptions(
        saleTeams.map((saleTeam) => ({
          value: saleTeam.teamId,
          label: saleTeam.name,
        }))
      );

      setIsSalesTeamLoaded(true);
    } catch (error) {
      console.error("Error fetching sales team data:", error);
      toast.error("Failed to load sales teams");
    }
  };

  useEffect(() => {
    fetchSalesTeamData();
  }, []);

  const getAmenitiesData = useCallback(async () => {
    if (isAmenitiesLoaded) return;

    try {
      const response = await AmenitiesService.getAmentities();
      const data = response.data || [];

      const basicAms = data
        .filter((item) => item.type === 1)
        .map((item) => ({
          value: item.id,
          label: item.name,
        }));
      setBasicAmenities(basicAms);

      const featuresAms = data
        .filter((item) => item.type === 2)
        .map((item) => ({
          value: item.id,
          label: item.name,
        }));
      setFeaturesAmenities(featuresAms);

      const nearbyAms = data
        .filter((item) => item.type === 3)
        .map((item) => ({
          value: item.id,
          label: item.name,
        }));
      setNearbyAmenities(nearbyAms);

      setIsAmenitiesLoaded(true);
    } catch (error) {
      console.error("Error fetching amenities data:", error);
      //    toast.error("Failed to load amenities");
      setBasicAmenities([]);
      setFeaturesAmenities([]);
      setNearbyAmenities([]);
    }
  }, [isAmenitiesLoaded]);

  useEffect(() => {
    // fetchSalesTeamData();
    getAmenitiesData();
  }, [getAmenitiesData]);

  useEffect(() => {
    if (!isAmenitiesLoaded) return;

    if (
      propertyInfo?.basicAmenitiesIds &&
      propertyInfo.basicAmenitiesIds.length > 0
    ) {
      const selected = basicAmenities.filter((am) =>
        propertyInfo.basicAmenitiesIds.includes(am.value)
      );
      setSelectedBasicAmenities(selected);
    }

    if (
      propertyInfo?.futureAmenitiesIds &&
      propertyInfo.futureAmenitiesIds.length > 0
    ) {
      const selected = featuresAmenities.filter((am) =>
        propertyInfo.futureAmenitiesIds.includes(am.value)
      );
      setSelectedFeaturesAmenities(selected);
    }

    if (
      propertyInfo?.nearByAmenitiesIds &&
      propertyInfo.nearByAmenitiesIds.length > 0
    ) {
      const selected = nearbyAmenities.filter((am) =>
        propertyInfo.nearByAmenitiesIds.includes(am.value)
      );
      setSelectedNearbyAmenities(selected);
    }
  }, [
    isAmenitiesLoaded,
    propertyInfo?.basicAmenitiesIds,
    propertyInfo?.futureAmenitiesIds,
    propertyInfo?.nearByAmenitiesIds,
    basicAmenities,
    featuresAmenities,
    nearbyAmenities,
  ]);

  useEffect(() => {
    if (!isSalesTeamLoaded || !salesTeamOptions.length) return;

    if (propertyInfo?.salesTeamIds && propertyInfo.salesTeamIds.length > 0) {
      const selected = salesTeamOptions.filter((team) =>
        propertyInfo.salesTeamIds.includes(team.value)
      );
      setSelectedSalesTeam(selected);
    }
  }, [isSalesTeamLoaded, propertyInfo?.salesTeamIds, salesTeamOptions]);

  useEffect(() => {
    setThumbnail(propertyInfo?.propertyThumbnail || "");
    setVideoLink(propertyInfo?.propertyVideos?.[0] || "");
  }, [propertyInfo]);

  const convertToInputDateFormat = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("/")) {
      const [day, month, year] = dateString.split("/");
      if (!day || !month || !year) return "";
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    if (dateString.includes("-")) {
      const parsedDate = new Date(dateString);
      if (isNaN(parsedDate)) return "";
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const day = String(parsedDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  const locationOptions = locationData.map((loc) => ({
    value: loc.id,
    label: loc.label,
  }));

  const handleThumbnailChange = async (e) => {
    const file = e.target.files[0];
    if (file && file.size < 1024 * 1024) {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        const response = await SpinWheelService.createBannerImageTemplate(
          formData,
          "thumbnails"
        );
        if (response?.data?.imageUrl) {
          setThumbnail(response.data.imageUrl);
          handlePropertyInfoChange({
            target: {
              name: "propertyThumbnail",
              value: response.data.imageUrl,
            },
          });
        } else {
          toast.error("Failed to upload thumbnail");
        }
      } catch (error) {
        console.error("Thumbnail upload error:", error);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please select an image under 1MB.");
    }
  };

  const handleRemoveImage = () => {
    setThumbnail("");
    handlePropertyInfoChange({
      target: { name: "propertyThumbnail", value: "" },
    });
    document.getElementById("thumbnail-upload").value = "";
  };

  const handleVideoLinkChange = (e) => {
    const url = e.target.value;
    const isValid =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[\w\-]+/.test(
        url
      );
    if (isValid) {
      setVideoError(false);
    } else {
      setVideoError(true);
    }
    url === "" || isValid ? setVideoLink(url) : setVideoError(true);
  };

  const handleAmenitiesChange = (type, selected) => {
    const ids = selected.map((s) => s.value);

    if (type === "basic") {
      setSelectedBasicAmenities(selected);
    } else if (type === "features") {
      setSelectedFeaturesAmenities(selected);
    } else if (type === "nearby") {
      setSelectedNearbyAmenities(selected);
    }

    setPropertyInfo((prev) => ({
      ...prev,
      ...(type === "basic" && { basicAmenitiesIds: ids }),
      ...(type === "features" && { futureAmenitiesIds: ids }),
      ...(type === "nearby" && { nearByAmenitiesIds: ids }),
    }));
  };

  const handleSalesTeamChange = (values) => {
    setSelectedSalesTeam(values);
    const ids = values.map((option) => option.value);
    handleArrayFieldChange("salesTeamIds", ids);
  };

  console.log("Property Info Form", propertyInfo?.propertyImages);
  const accordionItems = [
    {
      title: "Property Basic Info",
      content: (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full">
          <div className="space-y-4">
            <div className="relative w-full h-60 group border-2 border-dashed border-gray-300 rounded-xl hover:border-emerald-400 transition-colors duration-200 aspect-video bg-gray-50 overflow-hidden">
              {thumbnail ? (
                <>
                  <img
                    src={thumbnail}
                    alt="Thumbnail Preview"
                    className="object-cover w-full h-full rounded-xl"
                  />
                  <button
                    onClick={handleRemoveImage}
                    className="absolute top-2 right-2 p-1 rounded-full bg-white hover:bg-red-100 transition"
                  >
                    <IoCloseCircleOutline className="h-5 w-5 text-red-600" />
                  </button>
                </>
              ) : loading ? (
                <div className="absolute inset-0 flex flex-col gap-3 items-center justify-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-customGreen"></div>
                  <p className="text-sm text-gray-500 mt-2">Loading...</p>
                </div>
              ) : (
                <label
                  htmlFor="thumbnail-upload"
                  className="absolute inset-0 flex flex-col items-center justify-center p-6 cursor-pointer"
                >
                  <MdCloudUpload className="h-6 w-6 text-emerald-600 mb-3" />
                  <p className="text-sm font-medium text-gray-600">
                    Upload Thumbnail Layout
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    Recommended ratio: 16:9 (max 1MB)
                  </p>
                </label>
              )}
              <input
                type="file"
                id="thumbnail-upload"
                className="hidden"
                accept="image/*"
                onChange={handleThumbnailChange}
              />
            </div>
          </div>

          <div className="space-y-6 w-full">
            <div className="grid gap-4">
              <div className="grid grid-cols-2 gap-4 items-center">
                <label className="text-sm font-medium text-gray-700 flex items-center">
                  <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span>
                  Property Name
                </label>
                <input
                  type="text"
                  name="name"
                  maxLength={100}
                  value={propertyInfo?.name || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-full px-4 py-2 rounded-lg input-focus"
                  placeholder="Enter property name"
                />
              </div>

              {isEdit && (
                <div className="grid grid-cols-2 gap-4 items-center">
                  <label className="text-sm font-medium text-gray-700">
                    Property ID
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="docId"
                      value={propertyInfo?.propertyId || ""}
                      className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 bg-gray-100 cursor-not-allowed"
                      placeholder="Property ID"
                      readOnly
                    />
                    <VscLockSmall className="absolute text-xl right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Villa Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="flex items-center">
            {/* <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span> */}
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Overall Sq.Ft
            </label>
            <input
              type="text"
              name="overAllSqft"
              value={propertyInfo?.overAllSqft || ""}
              onChange={(e) => {
                const value = e.target.value;

                if (value.length <= 30) {
                  handlePropertyInfoChange(e);
                }
              }}
             
             
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Enter overall sqft"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              DTCP No.
            </label>
            <input
              type="text"
              name="dtcpNo"
              maxLength={20}
              value={propertyInfo?.dtcpNo || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="DTCP No."
            />
          </div>

          <div className="flex items-center">
            {/* <span className="w-1 h-5 bg-red-400 mr-2 rounded-sm"></span> */}

            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Guideline Value
            </label>
            <input
              type="number"
              name="guidelineValue"
              value={propertyInfo?.guidelineValue || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="In Number"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Document Type
            </label>
            <input
              type="text"
              name="documentType"
              maxLength={20}
              value={propertyInfo?.documentType || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Sale Deed"
            />
          </div>

       

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              ROI Percentage
            </label>
            <input
              type="number"
              name="roiPercentage"
              maxLength={2}
              value={propertyInfo?.roiPercentage || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="ROI Percentage"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              ROI Year
            </label>
            <input
              type="number"
              name="roiYear"
              value={propertyInfo?.roiYear || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,2}$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="ROI Year"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              RERA Number
            </label>
            <input
              type="text"
              name="reraId"
              value={propertyInfo?.reraId || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="RERA Number"
            />
          </div>
          {propertySaleTypesName === "Resale" && (
            <div className="flex items-center">
              <label className="w-[50%] block text-sm font-medium text-gray-700">
                Age of Property
              </label>
              <input
                type="number"
                name="ageOfTheProperty"
                value={propertyInfo?.ageOfTheProperty || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,2}$/.test(value)) {
                    handlePropertyInfoChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
                placeholder="Age of Property"
              />
            </div>
          )}

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Survey Fee
            </label>
            <input
              type="number"
              name="surveyFee"
              value={propertyInfo?.surveyFee || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Survey Fee "
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Survey Number
            </label>
            <input
              type="number"
              name="surveyNo"
              maxLength={10}
              value={propertyInfo?.surveyNo || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Survey Number"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Document Charge
            </label>
            <input
              type="number"
              name="documentCharge"
              value={propertyInfo?.documentCharge || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Document Charge (Max 10 digits)"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Property Purchased Date
            </label>
            <input
              type="date"
              name="propertyPurchasedDate"
              value={
                propertyInfo?.propertyPurchasedDate
                  ? convertToInputDateFormat(propertyInfo.propertyPurchasedDate)
                  : ""
              }
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
            />
          </div>


          {isEdit && (
            <div className="flex items-center">
              <label className="w-[50%] block text-sm font-medium text-gray-700">
                Purchased Day Count
              </label>

              <input
                type="text"
                name="purchaseDaysCount"
                value={propertyInfo?.purchaseDaysCount}
                onChange={handlePropertyInfoChange}
                readOnly
                className="w-[50%] px-3 bg-gray-100 py-2 input-focus rounded-md"
              />
            </div>
          )}

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Property Launch Date
            </label>
            <input
              type="date"
              name="possessionDate"
              value={
                propertyInfo?.possessionDate
                  ? convertToInputDateFormat(propertyInfo.possessionDate)
                  : ""
              }
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Registration Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
              Under Governance
            </label>
            <select
              name="underOfGovernance"
              value={propertyInfo?.underOfGovernance || ""}
              onChange={handlePropertyInfoChange}
              className="w-[70%] px-3 py-2 input-focus rounded-md"
            >
              <option value="">Select Governance</option>
              {underOfGovernances?.map((item) => (
                <option key={item.value} value={item.label}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
              SRO
            </label>
            <input
              type="text"
              name="sro"
              value={propertyInfo?.sro || ""}
              maxLength={20}
              onChange={handlePropertyInfoChange}
              className="w-[70%] px-3 py-2 input-focus rounded-md"
              placeholder="SRO"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
              Taluk
            </label>
            <input
              type="text"
              name="taluk"
              maxLength={20}
              value={propertyInfo?.taluk || ""}
              onChange={handlePropertyInfoChange}
              className="w-[70%] px-3 py-2 input-focus rounded-md"
              placeholder="Taluk"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Charges",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {propertyInfo?.propertySaleName === "Resale" && (
            <div className="flex items-center">
              <label className="w-[50%] block text-sm font-medium text-gray-700">
                Commission
              </label>
              <input
                type="number"
                name="commission"
                maxLength={10}
                value={propertyInfo?.commission || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handlePropertyInfoChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                 onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
                placeholder="Commission"
              />
            </div>
          )}

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
            Fully Covered Parking
            </label>
            <input
              type="number"
              name="fullyCoveredParkingCharge"
              maxLength={10}
              value={propertyInfo?.fullyCoveredParkingCharge || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Fully Covered Parking"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Semi Covered Parking
            </label>
            <input
              type="number"
              name="semiCoveredParkingCharge"
              maxLength={10}
              value={propertyInfo?.semiCoveredParkingCharge || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Semi Covered Parking"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Open Covered Parking
            </label>
            <input
              type="number"
              name="openParkingCharge"
              maxLength={10}
              value={propertyInfo?.openParkingCharge || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Open Covered Parking"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Address Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="w-full h-70 rounded-md overflow-hidden border">
            {propertyInfo?.geoLocation ? (
              <iframe
                src={`https://www.google.com/maps?q=${propertyInfo.geoLocation}&output=embed`}
                className="w-full h-full"
                title="Map Preview"
                allowFullScreen
                loading="lazy"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400 bg-gray-100">
                Map preview will appear here
              </div>
            )}
          </div>

          <div className="space-y-4">
            <div className="flex items-center">
              <label className="w-[50%] block text-sm font-medium text-gray-700">
                <span className="border-red-400 border-l-4 mr-1 rounded-md"></span>
                Location
              </label>
              <div className="w-[50%]">
                <Select
                  options={locationOptions}
                  value={
                    locationOptions.find(
                      (option) => option.value === propertyInfo?.locationId
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handlePropertyInfoChange({
                      target: {
                        name: "locationId",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  placeholder="Select Location"
                  isSearchable
                />
              </div>
            </div>

            <div className="flex items-center">
              <label className="w-[50%] block text-sm font-medium text-gray-700">
                <span className="border-red-400 border-l-4 mr-1 rounded-md"></span>
                Type latitude and longitude
              </label>
              <input
                type="text"
                name="geoLocation"
                value={propertyInfo?.geoLocation || ""}
                onChange={(e) => {
                  const cleaned = e.target.value
                    .replace(/°/g, "")
                    .replace(/[NSEW]/gi, "")
                    .replace(/\s+/g, "");

                  handlePropertyInfoChange({
                    target: {
                      name: "geoLocation",
                      value: cleaned,
                    },
                  });
                }}
                placeholder="e.g., 12.9249, 80.1000"
                className="w-[50%] px-3 py-2 border rounded-md input-focus"
              />
            </div>

            <div className="flex items-center">
              <label className="w-[50%] block text-sm font-medium text-gray-700">
                <span className="border-red-400 border-l-4 mr-1 rounded-md"></span>
                Address
              </label>
              <textarea
                name="address"
                value={propertyInfo?.address || ""}
                onChange={handlePropertyInfoChange}
                placeholder="Address"
                className="w-[50%] h-20 px-3 py-2 border rounded-md input-focus"
              />
            </div>

            <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Landmark
            </label>
            <textarea
              type="text"
              name="landmark"
            rows={2}
              value={propertyInfo?.landmark || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Near"
            />
          </div>

            <div className="flex w-full items-center">
              <label className="w-[50%]  text-nowrap block text-sm font-medium text-gray-700">
                Location Link
              </label>
              <input
                type="text"
                name="locationLink"
                value={propertyInfo?.locationLink || ""}
                onInput={(e) => {
                  const value = e.target.value;
                  const youtubeRegex =
                    /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/;

                  if (value === "" || youtubeRegex.test(value)) {
                    handlePropertyInfoChange(e);
                  } else {
                    e.target.value = propertyInfo?.locationLink || "";
                  }
                }}
                placeholder="Enter G-Map link only"
                className="w-1/2 px-3 py-2 border rounded-md input-focus"
              />
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Sales Team",
      content: (
        <div className="grid grid-cols-1 gap-6">
          <MultiSelectDropdown
            label="Select Sales Team"
            options={salesTeamOptions}
            selectedValues={selectedSalesTeam}
            onClick={fetchSalesTeamData}
            onChange={handleSalesTeamChange}
            placeholder="Select sales team"
            isMulti
          />
        </div>
      ),
    },
    {
      title: "Amenities",
      content: (
        <div className="grid grid-cols-3 gap-6">
          <MultiSelectDropdown
            label="Basic"
            options={basicAmenities}
            selectedValues={selectedBasicAmenities}
            //  onClick={() => fetchAmenitiesData(1)}
            onChange={(values) => handleAmenitiesChange("basic", values)}
            placeholder="Select basic amenities"
          />
          <MultiSelectDropdown
            label="Features"
            options={featuresAmenities}
            selectedValues={selectedFeaturesAmenities}
            //   onClick={() => fetchAmenitiesData(2)}
            onChange={(values) => handleAmenitiesChange("features", values)}
            placeholder="Select property features"
          />
          <MultiSelectDropdown
            label="Nearby"
            options={nearbyAmenities}
            selectedValues={selectedNearbyAmenities}
            //  onClick={() => fetchAmenitiesData(3)}
            onChange={(values) => handleAmenitiesChange("nearby", values)}
            placeholder="Select nearby facilities"
          />
        </div>
      ),
    },
    {
      title: "Media Info",
      content: (
        <div className="grid grid-cols-1 gap-8">
          <MediaUpload
            mediaType="propertyImages"
            files={propertyInfo?.propertyImages || []}
            onChange={(urls) => handleArrayFieldChange("propertyImages", urls)}
            accept="image/*"
            maxFiles={5}
            folderpath="property_images"
          />
          <MediaUpload
            mediaType="propertyBlueprints"
            files={propertyInfo?.propertyBlueprints || []}
            onChange={(urls) =>
              handleArrayFieldChange("propertyBlueprints", urls)
            }
            accept="image/*,application/pdf,application/dwg,application/x-dwg,application/dxf,application/x-dxf"
            maxFiles={5}
            folderpath="property_blueprints"
          />
          <MediaUpload
            mediaType="propertyDocuments"
            files={propertyInfo?.propertyDocuments || []}
            onChange={(urls) =>
              handleArrayFieldChange("propertyDocuments", urls)
            }
            accept="application/pdf,application/dwg,application/x-dwg,application/dxf,application/x-dxf"
            maxFiles={5}
            folderpath="property_documents"
          />
          <MediaUpload
            mediaType="propertyFlyers"
            files={propertyInfo?.propertyFlyers || []}
            onChange={(urls) => handleArrayFieldChange("propertyFlyers", urls)}
            accept="image/*"
            maxFiles={5}
            folderpath="property_flyers"
          />

<div className="flex flex-col gap-1">
          <label className="text-sm font-medium text-gray-700">
            Drive Link
          </label>
          <input
            type="text"
            name="driveLink"
            value={propertyInfo?.driveLink}
            onChange={handlePropertyInfoChange}
            className="w-full px-3 py-2 border rounded-md input-focus"
            placeholder="Copy paste the Drive link"
          />
        </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Video Link
            </label>
            <input
              type="url"
              value={videoLink}
              onChange={handleVideoLinkChange}
              className="w-full px-3 py-2 border rounded-md input-focus"
              placeholder="Copy paste the youtube video link"
            />
            {videoError && (
              <p className="text-red-600 text-sm mt-1">
                Only YouTube links (youtube.com or youtu.be) are allowed.
              </p>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "More Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Total Project Worth
            </label>
            <input
              type="number"
              name="totalProjectWorth"
              value={propertyInfo?.totalProjectWorth || ""}
              onChange={(e) => {
                const value = e.target.value;

                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
               onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Rupees "
            />
          </div>
          {isEdit && (
            <>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Overall Saleable SQ.FT
                </label>
                <input
                  type="number"
                  name="overallSaleableSqft"
                  value={propertyInfo?.overAllSaleableSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] px-3 bg-gray-100 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Total Units Available
                </label>
                <input
                  type="number"
                  name="totalAvailableUnits"
                  value={propertyInfo?.totalAvailableUnits || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] px-3 py-2 bg-gray-100 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Overall SQ.FT Available
                </label>
                <input
                  type="number"
                  name="overAllAvailableSqft"
                  value={propertyInfo?.overAllAvailableSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] px-3 bg-gray-100 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Available Min. SQ.FT
                </label>
                <input
                  type="number"
                  name="availableMinSqft"
                  value={propertyInfo?.availableMinSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Available Max. SQ.FT
                </label>
                <input
                  type="number"
                  name="availableMaxSqft"
                  value={propertyInfo?.availableMaxSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Available Min. Budget
                </label>
                <input
                  type="number"
                  name="availableMinBudget"
                  value={propertyInfo?.availableMinBudget || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Rupees"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Available Max. Budget
                </label>
                <input
                  type="number"
                  name="availableMaxBudget"
                  value={propertyInfo?.availableMaxBudget || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Rupees"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Booked Unit Count
                </label>
                <input
                  type="number"
                  name="bookedUnitcount"
                  value={propertyInfo?.bookedUnitcount || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Booked Unit SQ.FT
                </label>
                <input
                  type="number"
                  name="overAllBookedSqft"
                  value={propertyInfo?.overAllBookedSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Agreement Unit Count
                </label>
                <input
                  type="number"
                  name="agreementUnitcount"
                  value={propertyInfo?.agreementUnitcount || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Agreement Unit SQ.FT
                </label>
                <input
                  type="number"
                  name="overAllAgreementSqft"
                  value={propertyInfo?.overAllAgreementSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Registered Unit Count
                </label>
                <input
                  type="number"
                  name="registeredUnitcount"
                  value={propertyInfo?.registeredUnitcount || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
              <div className="flex items-center">
                <label className="w-[50%] block text-sm font-medium text-gray-700">
                  Registered Unit SQ.FT
                </label>
                <input
                  type="number"
                  name="overAllRegisteredSqft"
                  value={propertyInfo?.overAllRegisteredSqft || ""}
                  onChange={handlePropertyInfoChange}
                  className="w-[50%] bg-gray-100 px-3 py-2 input-focus rounded-md"
                  placeholder="Number"
                  readOnly
                />
              </div>
            </>
          )}
        </div>
      ),
    },

    {
      title: "Possession Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
              Possession Status
            </label>
            <select
              name="constructionType"
              value={propertyInfo?.constructionType || ""}
              onChange={handlePropertyInfoChange}
              className="w-[70%] px-3 py-2 input-focus rounded-md"
            >
              <option value="" disabled>
                Select Possession Status
              </option>
              {constructionType.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      ),
    },

    {
      title: "Property Seller / Vendor Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
            Seller Name
            </label>
            <input
              type="text"
              name="propertySellerName"
              value={propertyInfo?.propertySellerName || ""}
              onChange={handlePropertyInfoChange}
              className="w-[70%] px-3 py-2 input-focus rounded-md"
              placeholder="Type Name"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
            Seller Phone Number
            </label>
            <div className="w-[70%]">
              <CustomInput
                type="number"
                name="propertySellerPhoneNumber"
                value={propertyInfo?.propertySellerPhoneNumber || ""}
                onChange={handlePropertyInfoChange}
                maxLength={10}
                className=" px-3 py-2 input-focus rounded-md"
                placeholder="Type Phone Number"
              />
            </div>

            {/* <input
              type="text"
              maxLength={10}
              name="propertySellerPhoneNumber"
              value={propertyInfo?.propertySellerPhoneNumber || ""}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                setPropertyInfo((prev) => ({
                  ...prev,
                  propertySellerPhoneNumber: onlyNums,
                }));
              }} 
              className="w-[70%] px-3 py-2 input-focus rounded-md"
              placeholder="Type Number"
            /> */}
          </div>

          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
            Vendor Name
            </label>
            <input
              type="text"
              name="propertyVendorName"
              value={propertyInfo?.propertyVendorName || ""}
              onChange={handlePropertyInfoChange}
              className="w-[70%] px-3 py-2 input-focus rounded-md"
              placeholder="Type Name"
            />
          </div>

          <div className="flex items-center">
            <label className="w-[30%] block text-sm font-medium text-gray-700">
            Vendor  Phone Number
            </label>
            <div className="w-[70%]">
              <CustomInput
                type="number"
                name="propertyVendorPhoneNumber"
                value={propertyInfo?.propertyVendorPhoneNumber || ""}
                onChange={handlePropertyInfoChange}
                maxLength={10}
                className=" px-3 py-2 input-focus rounded-md"
                placeholder="Type Phone Number"
              />
            </div>

            {/* <input
              type="text"
              maxLength={10}
              name="propertySellerPhoneNumber"
              value={propertyInfo?.propertySellerPhoneNumber || ""}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                setPropertyInfo((prev) => ({
                  ...prev,
                  propertySellerPhoneNumber: onlyNums,
                }));
              }} 
              className="w-[70%] px-3 py-2 input-focus rounded-md"
              placeholder="Type Number"
            /> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default VillaPropertyInfoForm;
